// extracted by mini-css-extract-plugin
export default {"title":"excerpt_title-module__title--3c8kX","visited":"excerpt_title-module__visited--3Lxqd"};